import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const Signup = () => {
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({
    fullname: "",
    mobile: "",
    password: "",
    cpassword: "",
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isPasswordVisibleOne, setIsPasswordVisibleOne] = useState(false);
  const toggleOnClickVisible = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const toggleOnClickVisibleOne = () => {
    setIsPasswordVisibleOne(!isPasswordVisibleOne);
  };
  const inputStyle = { width: "100%", maxWidth: "240px" };

  //   destructuring input fields
  const { fullname, mobile, password, cpassword } = inputValues;
  //   inputs onChange
  const OnChangeInputs = (e) => {
    const { name, value } = e.target;
    setInputValues((previousValues) => {
      return { ...previousValues, [name]: value };
    });
  };

  const toastStyle = { position: "top-center", autoClose: 1500 };

  //   register form onSubmit handle
  const onSubmitHandle = async (e) => {
    e.preventDefault();
    if (!fullname || !mobile || !password || !cpassword) {
      toast.warn("Can't submit!... please fill all the inputs!");
    } else {
      axios
        .post("https://cocktailshop.onrender.com/register", {
          fullname,
          mobile,
          password,
          cpassword,
        })
        .then((res) => {
          if (res.status === 201) {
            toast.success(res.data.message, toastStyle);
          }
          setInputValues({
            fullname: "",
            mobile: "",
            password: "",
            cpassword: "",
          });
          navigate("/login");
        })
        .catch((err) => {
          console.log(err);
          const status = err.response.status;
          const message = err.response.data.message;
          // console.log(message);
          if (status === 500) {
            toast.warn(message, toastStyle);
          } else if (status === 403) {
            toast.warn(message, toastStyle);
          } else if (status === 422) {
            toast.warn(message, toastStyle);
          }
        });
    }
  };
  return (
    <form onSubmit={onSubmitHandle} className="login-form w-3/4 mx-auto">
      <h1 className="text-center font-extrabold text-2xl form-h1 mt-4 text-blue-900">
        Create account
      </h1>
      <div className=" w-20 h-1 bg-gradient-to-r from-blue-900 to-pink-900 mt-2 mx-auto rounded"></div>
      <p className="text-center font-bold text-gray-600 my-6">
        Welcome to register page! Create your 1st Lou's account and <br></br>{" "}
        eligible to buy drink
      </p>

      <div className="w-full text-center">
        <div className="mx-auto" style={inputStyle}>
          <TextField
            label="Full Name"
            type="text"
            name="fullname"
            value={inputValues.fullname}
            onChange={OnChangeInputs}
            variant="standard"
            sx={inputStyle}
          />
          <TextField
            label="Mobile"
            type="number"
            name="mobile"
            value={inputValues.mobile}
            onChange={OnChangeInputs}
            variant="standard"
            sx={inputStyle}
          />
        </div>
        <div className="relative mx-auto" style={inputStyle}>
          <TextField
            label="Password"
            type={isPasswordVisible ? "text" : "password"}
            name="password"
            value={inputValues.password}
            onChange={OnChangeInputs}
            variant="standard"
            sx={inputStyle}
            autoComplete="off"
          />
          <span
            onClick={toggleOnClickVisible}
            className="absolute bottom-2 right-2 cursor-pointer text-xl hover:text-blue-500"
          >
            {isPasswordVisible ? <AiFillEye /> : <AiFillEyeInvisible />}
          </span>
        </div>
        <div className="relative mx-auto" style={inputStyle}>
          <TextField
            label="Confirm Password"
            type={isPasswordVisibleOne ? "text" : "password"}
            name="cpassword"
            value={inputValues.cpassword}
            onChange={OnChangeInputs}
            variant="standard"
            sx={inputStyle}
            autoComplete="off"
          />
          <span
            onClick={toggleOnClickVisibleOne}
            className="absolute bottom-2 right-2 cursor-pointer text-xl hover:text-blue-500"
          >
            {isPasswordVisibleOne ? <AiFillEye /> : <AiFillEyeInvisible />}
          </span>
        </div>
        <button
          type="submit"
          className="mt-7 py-1 flex justify-center items-center mx-auto rounded hover:text-amber-500 font-extrabold  btn-login"
        >
          <BsArrowRightCircleFill style={{ marginRight: "5px" }} /> Register
        </button>
        <p className=" font-semibold mt-2">
          Already have an account!
          <Link
            to="/login"
            className=" text-blue-400 hover:text-blue-700 hover:underline"
          >
            Signin Now
          </Link>
        </p>
      </div>
    </form>
  );
};

export default Signup;
